import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NavigationMenu from "../NavigationMenu/NavigationMenu";
import styles from "./Header.module.scss";

const Header = ({ isMenuOpen, setIsMenuOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    navigate("/");
  };

  const scrollToContact = () => {
    setIsMenuOpen(false);

    if (location.pathname === "/") {
      const section = document.querySelector("#contact");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: "contact" } });
    }
  };

  return (
    <header className="fixed h-[6.4rem] w-[32rem] top-2 left-0 right-0 mx-auto z-50 ">
      <div className="container-custom">
        <div className="flex items-center justify-between h-[6.4rem] px-4 sm:px-6 lg:px-8">
          <nav className="flex items-center justify-center space-x-8 w-full">
            <div className={styles.navBar}>
              <img
                src="/vertik-logo-name.png"
                className={styles.logo}
                alt="Vertik AI"
                onClick={handleLogoClick}
                style={{ cursor: "pointer" }}
              />
              <div
                className={styles.navIcon}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <span className={styles.navIconDot}></span>
                <span className={styles.navIconDot}></span>
                <span className={styles.navIconDot}></span>
                <span className={styles.navIconDot}></span>
                <span className={styles.navIconDot}></span>
                <span className={styles.navIconDot}></span>
                <span className={styles.navIconDot}></span>
                <span className={styles.navIconDot}></span>
                <span className={styles.navIconDot}></span>
              </div>

              <img
                src="/navButton.svg"
                className={styles.navCtaIcon}
                alt="Contact US"
                onClick={scrollToContact}
                style={{ cursor: "pointer" }}
              />
            </div>
          </nav>
        </div>

        {isMenuOpen && (
          <NavigationMenu
            setIsMenuOpen={setIsMenuOpen}
            onLogoClick={handleLogoClick}
          />
        )}
      </div>
    </header>
  );
};

export default Header;
